import { render, staticRenderFns } from "./SearchProductsComposite.vue?vue&type=template&id=4744465e"
import script from "./SearchProductsComposite.vue?vue&type=script&lang=js"
export * from "./SearchProductsComposite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports